import { useUserData } from "@me8eon/react_authentication";
import {  useAgentSelectorContext } from "./react.intent";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getAccessibleIndices, isAgentAccessible } from "@me8eon/agent";
import { isCompassFeatureFlagEnabled } from "@me8eon/compass_data_plugin";
import { isHigherEnv } from "me-at-eon/src/util/common-util";
import {useAgentContext} from "./context/AgentContext";

export function useAgentSelector() {
    const [selectedAgent, setSelectedAgent] = useAgentSelectorContext();
    const intent = useAgentContext()
    const { empType } = useUserData();
    const isCompassFeatureEnabled = isCompassFeatureFlagEnabled(empType);
    const accessibleIndices = useMemo(() => getAccessibleIndices(), []);
    const allAgentsNotHigherEnv = Object.entries(intent.cards.cards).map(([_key, value]) => ({ ...value }));
    const allAgentsHigherEnv = allAgentsNotHigherEnv.filter((obj) => obj.name !== "nautilus");
    const allAgents = isHigherEnv() ? allAgentsHigherEnv : allAgentsNotHigherEnv;

    // Filter agents based on disableStandaloneSelection AND ACL access
    const selectableAgents = allAgents.filter(agent => {
        // Filter out agents with disableStandaloneSelection
        if (agent?.disableStandaloneSelection) return false;

        // Filter out agents the user has no ACL access to
        if (!isAgentAccessible(agent, accessibleIndices)) return false;

        // Filter out compass agent if feature flag is disabled
        if (!isCompassFeatureEnabled && agent?.name === 'compass') return false;

        return true;
    });

    const selectAgent = useCallback((agent: typeof selectableAgents[number] | undefined) => {
        setSelectedAgent(agent);
    }, [allAgents]);

    return {
        allAgents,
        selectableAgents,
        selectedAgent,
        selectAgent,
    };
}